import { Box, CTABlock } from '@ads-core/components';
import { useMedia } from 'react-use';
import { mq } from '@ads-core/breakpoints';
import { PolygonMap } from '../PolygonMap';
import { CongestionMessage } from './_Message';
import { CTAFallBack } from './_CTAFallBack';
import { MappedCongestionDataProps } from './types/mappedResponse';

type CTAImageContainerProps = {
  postalCode: string;
  congestionData?: MappedCongestionDataProps;
  toggleMessage: boolean;
  handleToggleMessage: (toggle: boolean) => void;
};

export const CTAImageContainer = ({
  postalCode,
  congestionData,
  toggleMessage,
  handleToggleMessage,
}: CTAImageContainerProps) => {
  const isDesktop = useMedia(mq.md);

  return (
    <CTABlock.Column columnStart={{ initial: '1', md: '7' }} columnEnd="-1">
      <CTABlock.ImageContainer
        overlay={
          congestionData && toggleMessage ? (
            <CTABlock.Notification
              handleOnClose={() => handleToggleMessage}
              arrowColor="containerPrimary"
            >
              <CongestionMessage
                title={congestionData.feedbackTitle}
                description={congestionData.feedbackText}
                buttonPrimary={congestionData.feedbackPrimaryButton}
                buttonSecondary={congestionData.feedbackSecondaryButton}
              />
            </CTABlock.Notification>
          ) : null
        }
      >
        {postalCode || (!isDesktop && postalCode && !toggleMessage) ? (
          <Box
            width="100%"
            height={{ initial: '358px', md: '100%' }}
            overflow="hidden"
          >
            <PolygonMap postalCode={postalCode} />
          </Box>
        ) : (
          <CTAFallBack />
        )}
      </CTABlock.ImageContainer>
    </CTABlock.Column>
  );
};
